<template>
  <div>
    <v-skeleton-loader
      v-if="dataLoading"
      class="mx-auto"
      type="table"
    ></v-skeleton-loader>
    <v-data-table
      v-if="!dataLoading"
      :headers="headers"
      :items="getUsers"
      :sort-by="['username']"
      :search="search"
      style="cursor: pointer"
      @click:row="onUserRowClicked"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <template>
            <v-btn
              small
              color="success"
              dark
              class="mb-2"
              @click="showCreateDialog = true"
            >
              <v-icon small dense class="mr-2">mdi-account-plus</v-icon>Create
              User
            </v-btn>
            <v-btn
              small
              color="success"
              dark
              class="mb-2"
              style="margin-left: 5px"
              @click="refreshCognitoUsers"
            >
              <v-icon small dense>mdi-refresh</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              small
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              hint="Search on user name or email etc"
            ></v-text-field>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:[`item.cognitoUser.Enabled`]="{ item }">
        <v-chip
          v-if="item.cognitoUser.Enabled !== undefined"
          :color="item.cognitoUser.Enabled ? 'green' : 'grey'"
          small
          label
          outlined
        >
          <v-avatar left>
            <v-icon small>{{
              item.cognitoUser.Enabled
                ? "mdi-check-circle-outline"
                : "mdi-minus-circle"
            }}</v-icon>
          </v-avatar>
          {{ item.cognitoUser.Enabled ? "Enabled" : "Disabled" }}
        </v-chip>
        <span v-else>{{ "-" }}</span>
      </template>
      <template v-slot:[`item.cognitoUser.email`]="{ item }">
        {{ item.cognitoUser.email || "-" }}
      </template>
      <template v-slot:[`item.cognitoUser.custom:ledger_access`]="{ item }">
        {{ item.cognitoUser[`custom:ledger_access`] =='1' ?'Yes':'No' }}
      </template>
      <template v-slot:[`item.cognitoUser.UserStatus`]="{ item }">
        <v-chip
          v-if="item.cognitoUser.UserStatus !== undefined"
          dense
          small
          :color="
            item.cognitoUser.UserStatus == 'CONFIRMED' ? 'green' : '#0073bb'
          "
          label
          text-color="white"
        >
          {{ item.cognitoUser.UserStatus }}
        </v-chip>
        <span v-else>{{ "-" }}</span>
      </template>
      <template v-slot:[`item.SSOUser`]="{ item }">
        {{ item.SSOUser ? "Yes" : "No" }}
      </template>
    </v-data-table>
    <v-dialog v-model="showEditDialog" max-width="700px" persistent>
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title>Edit User</v-toolbar-title>
            <v-btn
              class="cancelButton"
              icon
              small
              @click="showEditDialog = false"
              ><v-icon class="white--text">mdi-close</v-icon></v-btn
            >
          </div>
        </v-toolbar>
        <v-card-text>
          <v-container class="pa-5 mt-5">
            <v-row>
              <v-col>
                <v-row>User Name </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.username }}
                </v-row>
                <v-row>Role </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.role }}
                </v-row>
                <v-row>SSO User </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.SSOUser ? "Yes" : "No" }}
                </v-row>
              </v-col>
              <v-divider vertical inset class="mx-4"></v-divider>
              <v-col>
                <v-row>Email </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.cognitoUser.email || "-" }}
                </v-row>
                <v-row>Account Status </v-row>
                <v-row class="mb-5 font-weight-black"
                  ><v-chip
                    v-if="editUserObj.cognitoUser.Enabled !== undefined"
                    :color="editUserObj.cognitoUser.Enabled ? 'green' : 'grey'"
                    small
                    label
                    outlined
                  >
                    <v-avatar left>
                      <v-icon small>{{
                        editUserObj.cognitoUser.Enabled
                          ? "mdi-check-circle-outline"
                          : "mdi-minus-circle"
                      }}</v-icon>
                    </v-avatar>
                    {{
                      editUserObj.cognitoUser.Enabled ? "Enabled" : "Disabled"
                    }}
                  </v-chip>
                  <span v-else>-</span>
                </v-row>
                <v-row>Confirmation Status </v-row>
                <v-row class="mb-5 font-weight-black">
                  <v-chip
                    v-if="editUserObj.cognitoUser.UserStatus !== undefined"
                    dense
                    small
                    :color="
                      editUserObj.cognitoUser.UserStatus == 'CONFIRMED'
                        ? 'green'
                        : '#0073bb'
                    "
                    label
                    text-color="white"
                  >
                    {{ editUserObj.cognitoUser.UserStatus }}
                  </v-chip>
                  <span v-else>-</span>
                </v-row>
              </v-col>
              <v-divider vertical inset class="mx-4"></v-divider>
              <v-col>
                  <v-row>Ledger Access </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.cognitoUser[`custom:ledger_access`] =='1' ? "Yes" : "No" }}
                </v-row>
                <v-row>Access</v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.access }}
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-2">
          <v-spacer></v-spacer>
          <v-btn
            v-if="editUserObj.cognitoUser.Enabled"
            small
            color="warning"
            @click="onUserDisable(editUserObj.username)"
            :disabled="!editUserObj.cognitoUser.Enabled"
            >Disable</v-btn
          >
          <v-btn
            v-if="editUserObj.cognitoUser.Enabled===false"
            small
            color="success"
            @click="onUserEnable(editUserObj.username)"
            :disabled="editUserObj.cognitoUser.Enabled"
            >Enable</v-btn
          >
          <v-btn
            small
            color="error"
            @click="onUserDelete(editUserObj.username)"
            :disabled="editUserObj.cognitoUser.Enabled"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="showCreateDialog"
      v-model="showCreateDialog"
      max-width="700px"
      persistent
    >
      <v-form ref="createUserForm">
        <v-card>
          <v-toolbar color="#425058" dark dense>
            <div class="titleBar-content">
              <v-toolbar-title class="raceResults-title"
                >Create GRN User</v-toolbar-title
              >
              <v-btn
                class="cancelButton"
                icon
                small
                @click="showCreateDialog = false"
                ><v-icon class="white--text">mdi-close</v-icon></v-btn
              >
            </div>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              label="Email"
              class="mt-2"
              :rules="emailRules"
              outlined
              dense
              v-model="newUserObj.email"
            ></v-text-field>
             
            <v-select
              v-model="newUserObj.role"
              :items="roleOptions"
              item-text="text"
              item-value="value"
              label="Role"
              outlined
              requird
              :rules="[(v) => v != undefined || 'Role is required']"
            ></v-select>
            <v-text-field
              label="Access"
              class="mt-2"
              :rules="accessRules"
              outlined
              dense
              v-model="newUserObj.access"
            ></v-text-field>
             <v-switch
             color="success"
             inset
            v-model="newUserObj.ledger_access"
            true-value="1"
            false-value="0"
            :label="`Ledger Access: ${newUserObj.ledger_access == '1' ?'Yes':'No'}`"
            ></v-switch>
            <v-switch
             color="success"
             inset
            v-model="newUserObj.SSOUser"
            :label="`SSO User: ${newUserObj.SSOUser?'Yes':'No'}`"
            ></v-switch>
          </v-card-text>
          <v-card-actions
            class="mt2"
            style="padding-bottom: 26px; padding-top: 26px"
          >
            <v-spacer></v-spacer>
            <v-btn small color="error" @click="showCreateDialog = false"
              >Cancel</v-btn
            >
            <v-btn small color="success" @click="confirmCreateUser"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <ConfirmDialog ref="confirm" />
  </div>
</template>
<script>
import Ajv from "ajv";
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "./common/ConfirmDialog.vue";
export default {
  data() {
    return {
      ajv: new Ajv(),
      showCreateDialog: false,
      showEditDialog: false,
      newUserObj: {},
      editUserObj: {
        cognitoUser: {},
      },
      dataLoading: false,
      search: "",
      headers: [
        {
          text: "User Name",
          value: "username",
        },
        {
          text: "Role",
          value: "role",
        },
        {
          text: "Access",
          value: "access",
        },
        {
          text: "Ledger Access",
          value: 'cognitoUser.custom:ledger_access',
        },
        {
          text: "SSO User",
          value: "SSOUser",
        },
        {
          text: "Email",
          value: "cognitoUser.email",
        },
        {
          text: "Confirmation Status",
          value: "cognitoUser.UserStatus",
        },
        {
          text: "Status",
          value: "cognitoUser.Enabled",
        },
      ],
      roleOptions: [
        { text: "User", value: 'User' },
        { text: "Developer", value: 'Developer' },
      ],
      accessRules: [
        (v) => !!v || "Access is required",
        (v) =>
           this.validateAccessData(v) ||
          `Access must be a valid JSON format,example:
          {"type": ["THOROUGHBRED"], "state" : ["NSW", "QLD"], "country": ["AUS"],"track_name": ["Eagle Farm"],"source" : ["PSQ"],"user_state" : ["TAS"]}`,
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      accessSchema: {
        type: "object",
        properties: {
          track_name: { type: "array",uniqueItems: true,items: {type: "string"}},
          source: { type: "array",uniqueItems: true,items: {type: "string"} },
          type: { type: "array" ,uniqueItems: true,items: {type: "string"}},
          state: { type: "array",uniqueItems: true,items: {type: "string"} },
          country: { type: "array",uniqueItems: true,items: {type: "string"} },
          user_state: { type: "array" ,uniqueItems: true,items: {type: "string"}}
        },
        additionalProperties: false,
      },
    };
  },
  async created() {
    await this.refreshCognitoUsers();
  },
  watch: {
    showCreateDialog(newVal) {
      if (!newVal) this.newUserObj = {};
    },
    showEditDialog(newVal) {
      if (!newVal) this.editUserObj = { cognitoUser: {} };
    },
  },
  computed: {
    ...mapGetters("globalRaceNetwork", ["getUsers"]),
    users() {
      return this.getUsers;
    },
  },
  components: {
    ConfirmDialog,
  },
  methods: {
    ...mapActions("globalRaceNetwork", ["fetchUsers","createUser","updateUser",
      "deleteUser"]),
    validateAccessData(jsonData){
        const ajv = new Ajv({allErrors: true})
        const validate = ajv.compile(this.accessSchema)
        try{
            const data = JSON.parse(jsonData)
            return validate(data)
        }catch{
            return false
        }
        
    },
    async confirmCreateUser() {
      if (this.$refs.createUserForm.validate()) {
        await this.createUser(this.newUserObj);
        this.showCreateDialog = false;
        await this.refreshCognitoUsers();
      }
    },

    async refreshCognitoUsers() {
      this.dataLoading = true;
      await this.fetchUsers();
      this.dataLoading = false;
    },

    onUserRowClicked(rowData) {
      this.showEditDialog = true;
      this.editUserObj = rowData;
    },
    async onUserDisable(userName) {
      if (
        await this.$refs.confirm.open(
          `Disable user access for "${userName}"`,
          "This will disable this user's access to GRNR. They will be unable to sign in to GRNR. The user will not be deleted. You can restore the access by enabling this user again",
          { confirmText: "Disable", confirmColor: "warning" }
        )
      ) {
        this.showEditDialog = false;
        await this.updateUser({Username:userName,Action:0});
        await this.refreshCognitoUsers();
      }
    },
    async onUserDelete(userName) {
      if (
        await this.$refs.confirm.open(
          `Delete user "${userName}"`,
          "This will delete this user from the user pool. They will be permanently removed and will no longer be able to sign in",
          { confirmText: "Delete", confirmColor: "error" }
        )
      ) {
        this.showEditDialog = false;
        await this.deleteUser(userName);
        await this.refreshCognitoUsers();
      }
    },
    async onUserEnable(userName) {
      if (
        await this.$refs.confirm.open(
          `Enable user access for "${userName}"`,
          "This will enable this user's access to GRNR. They will be able to sign in to the GRNR.",
          { confirmText: "Enable", confirmColor: "success" }
        )
      ) {
        this.showEditDialog = false;
        await this.updateUser({Username:userName,Action:1});
        await this.refreshCognitoUsers();
      }
    },
  },
};
</script>
